export default __webpack_public_path__ + "static/media/work-learn.plant-based-arts.5a92afcd.png";